export default __webpack_public_path__ + "d8e8d56f18457ac568dd7f1aa70f1c61.svg";